import { createFileRoute } from '@tanstack/react-router';

import {
  AdminOverviewPage,
  adminUsageSearchSchema,
} from '@/features/organization-admin';

export const Route = createFileRoute('/admin/')({
  // The period lives in the address, like the workspace Usage page's own: a view of
  // last month is a thing an administrator sends to someone.
  validateSearch: adminUsageSearchSchema,
  component: AdminOverviewRoute,
});

export function AdminOverviewRoute() {
  const { period } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AdminOverviewPage
      period={period}
      onPeriodChange={(next) => {
        // `replace`, matching the workspace page: stepping through months should not
        // fill the back button with a trail to unwind on the way out.
        void navigate({ search: { period: next }, replace: true });
      }}
    />
  );
}
